export default Object.freeze({
  carrot: '#F68832',
  amber: '#FFAE00',
  zest: '#FFAE00',
  amberLite: '#FFBE00',
  oeYellow: '#F7BE07',
  citron: '#FFD200',
  turbo: '#FFE600',
  black: '#000',
  charcoal2: '#222',
  charcoal4: '#444',
  dove: '#666',
  fiveam: '#808080',
  aluminum: '#999',
  silver: '#BBB',
  rock: '#ccc',
  ash: '#DEDFE0',
  smoke: '#F5F5F5',
  white: '#FFF',
  offwhite: '#F8F8F8',
  cobalt: '#0070E0',
  cobaltLite: '#0085FF',
  cyan: '#0085FF',
  jade: '#00BC80',
  jadeLite: '#2EE09B',
  crimson: '#DC143C',
  crimsonLite: '#E34363',
  sky: '#DAECFF',
  slate: '#4E6C84',
  sunrise: '#ffe7b3',
  victoria: '#243646',
  notificationRed: '#FF5252',
  selectOptionFocusBackground: '#F1F1F1',
  questOverviewBackground: '#4e6c84',
  focusSkillBlue: '#EEF7FF'
})
